import { Auth } from "./types";

const defaultState = {
    isLoggedIn: false,
    view: "login",
    user: {},
    userRole: "trader",
    loginError: {},
    appInitFailed: false,
    // Consent gate. `termsRequired` blocks the app; `termsVersion` is the
    // version being asked for, shown on the modal.
    termsRequired: false,
    termsVersion: null,
    termsEffectiveDate: null,
    // `{ mfaEnforced }` when the MFA recommendation is waiting on the gate.
    mfaNoticeDeferred: null,
    // The version announced while this session was open, once it is not the
    // one the session signed in with.
    termsPublished: null,
    isReady: false,
    appReady: false,
    wsConnected: false,
    initComplete: false,
    apiBaseUrl: "",
    directoryUrl: "",
    confirmationUrl: "",
    eventsWssUrl: "",
    marketDataUrl: "",
    marketDataBatchUrl: "",
    txUrl: "",
    inventoryUrl: "",
    availabilityUrl: "",
    settingsUrl: "",
    recallUrl: "",
    positionsUrl: "",
    useClientPool: false,
    postTradeUrl: "",
    tradeMonitorUrl: "",
    adminServiceUrl: "",
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case Auth.SET_VIEW:
            return { ...state, view: action.view };

        case Auth.LOGIN:
            return { ...state, isLoggedIn: true, user: action.user, userRole: action.userRole || "trader" };

        case Auth.LOGOUT:
            return { ...state, isLoggedIn: false, user: {}, userRole: "trader",
                     wsConnected: false, initComplete: false };

        case Auth.IS_READY:
            return { ...state, isReady: true };

        case Auth.APP_READY:
            return { ...state, appReady: true };

        case Auth.APP_NOT_READY:
            return { ...state, appReady: false };

        case Auth.WS_CONNECTED:
            return { ...state, wsConnected: true,
                     appReady: state.appReady || state.initComplete };

        case Auth.INIT_COMPLETE:
            return { ...state, initComplete: true,
                     appReady: state.appReady || state.wsConnected };

        case Auth.INIT:
            return {
                ...state,
                apiBaseUrl: action.result.apiBaseUrl,
                directoryUrl: action.result.directoryUrl,
                confirmationUrl: action.result.confirmationUrl,
                eventsWssUrl: action.result.eventsWssUrl,
                marketDataUrl: action.result.marketDataUrl,
                marketDataBatchUrl: action.result.marketDataUrl + "/stocks",
                txUrl: action.result.txUrl,
                inventoryUrl: action.result.inventoryUrl,
                availabilityUrl: action.result.availabilityUrl,
                settingsUrl: action.result.settingsUrl,
                recallUrl: action.result.recallUrl,
                positionsUrl: action.result.positionsUrl,
                useClientPool: !!action.result.useClientPool,
                postTradeUrl: action.result.postTradeUrl,
                tradeMonitorUrl: action.result.tradeMonitorUrl,
                adminServiceUrl: action.result.adminServiceUrl,
            };

        case Auth.LOGIN_ERROR:
            return { ...state, loginError: action.error };

        case Auth.CLEAR_LOGIN_ERROR:
            return { ...state, loginError: {} };

        case Auth.APP_INIT_FAILED:
            return { ...state, appInitFailed: true };

        case Auth.TERMS_REQUIRED:
            return {
                ...state,
                termsRequired: true,
                termsVersion: action.version || null,
                termsEffectiveDate: action.effectiveDate || null,
            };

        case Auth.TERMS_ACCEPTED:
            return { ...state, termsRequired: false };

        case Auth.MFA_NOTICE_DEFERRED:
            return {
                ...state,
                mfaNoticeDeferred: {
                    mfaEnforced: !!action.mfaEnforced,
                    // Enrolment is mandatory and the session cannot boot until it
                    // happens, so the gate must not run the bootstrap after the
                    // terms are accepted.
                    mfaPending: !!action.mfaPending,
                },
            };

        case Auth.MFA_NOTICE_SHOWN:
            return { ...state, mfaNoticeDeferred: null };

        case Auth.TERMS_PUBLISHED:
            return { ...state, termsPublished: action.version || "" };

        default:
            return state;
    }
};
